import API from "../../Common/API";

export const BOOKINGS_API_URL = `${API.getBaseUrl()}bookings/`;

export const BOOKINGS_VIEWS = {
    MY_BOOKINGS: 'my-bookings',
    ALL_BOOKINGS: 'all-bookings',
}

export const BOOKINGS_TABS = {
    UPCOMING: 'upcoming',
    PAST: 'past',
};

export const URL = {
    BOOKINGS: `/bookings`,
    BOOKINGS_LOGS: '/bookings/logs',
    BOOKINGS_ALL: '/bookings/logs/all-bookings',
    BOOKINGS_ALL_UPCOMING: `/bookings/logs/all-bookings/${BOOKINGS_TABS.UPCOMING}`,
    BOOKINGS_ALL_PAST: `/bookings/logs/all-bookings/${BOOKINGS_TABS.PAST}`,

    BOOKINGS_MY: '/bookings/logs/my-bookings',
    BOOKINGS_MY_UPCOMING: `/bookings/logs/my-bookings/${BOOKINGS_TABS.UPCOMING}`,
    BOOKINGS_MY_ARCHIVED: `/bookings/logs/my-bookings/${BOOKINGS_TABS.PAST}`,

    MAKE_A_BOOKING: `/bookings`,
    MAKE_A_BOOKING_CATEGORY: `/bookings/book`,

    BOOKINGS_OVERVIEW: `/bookings/overview`,

    BOOKINGS_PAYMENT: `/bookings/payment`,
    BOOKINGS_CONFIRMATION: `/bookings/confirmation`,
}

export const ACTIONS = {
    VIEW: 'view',
    EDIT: 'edit',
    REMOVE: 'remove',
    CANCEL: 'cancel',
    DELETE: 'delete',
}

// Needs to match constants in Recurrence.php
export const UPDATE = {
    SINGLE: 'single',
    SERIES: 'series',
    SERIES_AFTER_EVENT: 'series-after',
}

export const SELECT_AMENITY_VIEWMODE = {
    LIST: 'list',
    CALENDAR: 'calendar',
};
